function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function Svg1944(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100%",
    width: "100%",
    viewBox: "0 0 700 700",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    key: 0,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 0,
    width: 22.22,
    height: 9.33,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 1.16625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.11,
    y: 4.665
  }, "\n        Hamilton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 1,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 9.33,
    width: 22.22,
    height: 21.92,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.74
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.11,
    y: 20.29
  }, "\n        Schuyler\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 2,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 31.26,
    width: 22.22,
    height: 29.16,
    style: {
      fill: "#B20000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.11,
    y: 45.84
  }, "\n        Yates\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 3,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 60.42,
    width: 22.22,
    height: 33.92,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.11,
    y: 77.38
  }, "\n        Lewis\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 4,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 94.34,
    width: 22.22,
    height: 37.71,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.468888888888889
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.11,
    y: 113.19500000000001
  }, "\n        Schoharie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 5,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 132.05,
    width: 22.22,
    height: 39.43,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.703333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.11,
    y: 151.76500000000001
  }, "\n        Putnam\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 6,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 171.48,
    width: 22.22,
    height: 40.81,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.703333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.11,
    y: 191.885
  }, "\n        Seneca\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 7,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 212.29,
    width: 22.22,
    height: 44.66,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.11,
    y: 234.62
  }, "\n        Tioga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 8,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 256.95,
    width: 22.22,
    height: 48.97,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.174285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.11,
    y: 281.435
  }, "\n        Orleans\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 9,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 305.92,
    width: 22.22,
    height: 51.29,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.174285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.11,
    y: 331.565
  }, "\n        Wyoming\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 10,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 357.2,
    width: 22.22,
    height: 51.67,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.444
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.11,
    y: 383.03499999999997
  }, "\n        Essex\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 11,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 408.87,
    width: 22.22,
    height: 52.6,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.703333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.11,
    y: 435.17
  }, "\n        Greene\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 12,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 461.47,
    width: 22.22,
    height: 53.91,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.7775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.11,
    y: 488.425
  }, "\n        Cortland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 13,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 515.38,
    width: 22.22,
    height: 60.49,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 2.7775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.11,
    y: 545.625
  }, "\n        Franklin\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 14,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 575.86,
    width: 22.22,
    height: 62.06,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.222
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.11,
    y: 606.89
  }, "\n        Livingston\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 15,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    y: 637.92,
    width: 22.22,
    height: 62.08,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 2.7775
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 11.11,
    y: 668.9599999999999
  }, "\n        Chenango\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 16,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.22,
    y: 0,
    width: 32.39,
    height: 43.78,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.04875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 38.415,
    y: 21.89
  }, "\n        Allegany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 17,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 54.6,
    y: 0,
    width: 33.32,
    height: 43.78,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.76
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 71.26,
    y: 21.89
  }, "\n        Clinton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 18,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 87.92,
    y: 0,
    width: 33.48,
    height: 43.78,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.579999999999999
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 104.66,
    y: 21.89
  }, "\n        Warren\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 19,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 121.4,
    y: 0,
    width: 34.57,
    height: 43.78,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.938571428571429
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 138.685,
    y: 21.89
  }, "\n        Madison\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 20,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 155.98,
    y: 0,
    width: 35.53,
    height: 43.78,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.44125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 173.745,
    y: 21.89
  }, "\n        Tompkins\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 21,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 191.51,
    y: 0,
    width: 35.56,
    height: 43.78,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.445
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 209.29,
    y: 21.89
  }, "\n        Delaware\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 22,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 227.06,
    y: 0,
    width: 35.57,
    height: 43.78,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 4.44625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 244.845,
    y: 21.89
  }, "\n        Columbia\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 23,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 262.64,
    y: 0,
    width: 35.73,
    height: 43.78,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.46625
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 280.505,
    y: 21.89
  }, "\n        Sullivan\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 24,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 298.37,
    y: 0,
    width: 36.01,
    height: 43.78,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.144285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 316.375,
    y: 21.89
  }, "\n        Genesee\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 25,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 334.38,
    y: 0,
    width: 37.19,
    height: 43.78,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.719
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 352.975,
    y: 21.89
  }, "\n        Washington\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 26,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 371.57,
    y: 0,
    width: 39.1,
    height: 43.78,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.516666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 391.12,
    y: 21.89
  }, "\n        Fulton\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 27,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 410.67,
    y: 0,
    width: 41.3,
    height: 43.78,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.883333333333333
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 431.32,
    y: 21.89
  }, "\n        Otsego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 28,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 451.98,
    y: 0,
    width: 43.51,
    height: 43.78,
    style: {
      fill: "#FF0000"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 8.702
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 473.735,
    y: 21.89
  }, "\n        Wayne\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 29,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 495.48,
    y: 0,
    width: 46.71,
    height: 43.78,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 6.2542857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 518.835,
    y: 21.89
  }, "\n        Ontario\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 30,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 542.19,
    y: 0,
    width: 49.76,
    height: 43.78,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.4725
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 567.07,
    y: 21.89
  }, "\n        Herkimer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 31,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 591.95,
    y: 0,
    width: 51.72,
    height: 43.78,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.378
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 617.8100000000001,
    y: 21.89
  }, "\n        Montgomery\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 32,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 643.67,
    y: 0,
    width: 56.33,
    height: 43.78,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 3.98
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 671.8349999999999,
    y: 21.89
  }, "\n        Cattaraugus\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 33,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.22,
    y: 43.78,
    width: 59.11,
    height: 42.46,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.076666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.775,
    y: 65.01
  }, "\n        Oswego\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 34,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.22,
    y: 86.24,
    width: 59.11,
    height: 42.82,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.136666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.775,
    y: 107.64999999999999
  }, "\n        Cayuga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 35,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.22,
    y: 129.06,
    width: 59.11,
    height: 43.3,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.4125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.775,
    y: 150.71
  }, "\n        Rockland\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 36,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.22,
    y: 172.36,
    width: 59.11,
    height: 44.73,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.59125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.775,
    y: 194.72500000000002
  }, "\n        Saratoga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 37,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.22,
    y: 217.09,
    width: 59.11,
    height: 47.67,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 5.296666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.775,
    y: 240.925
  }, "\n        Jefferson\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 38,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.22,
    y: 264.76,
    width: 59.11,
    height: 48.84,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 4.07
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.775,
    y: 289.18
  }, "\n        St._Lawrence\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 39,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.22,
    y: 313.6,
    width: 59.11,
    height: 49.02,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.002857142857144
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.775,
    y: 338.11
  }, "\n        Chemung\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 40,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.22,
    y: 362.62,
    width: 59.11,
    height: 51.27,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 7.324285714285715
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.775,
    y: 388.255
  }, "\n        Steuben\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 41,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.22,
    y: 413.9,
    width: 59.11,
    height: 57.43,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.571666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.775,
    y: 442.61499999999995
  }, "\n        Ulster\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 42,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.22,
    y: 471.32,
    width: 59.11,
    height: 72.4,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.911
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.775,
    y: 507.52
  }, "\n        Chautauqua\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 43,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.22,
    y: 543.73,
    width: 59.11,
    height: 73.26,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 7.38875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.775,
    y: 580.36
  }, "\n        Dutchess\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 44,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 22.22,
    y: 616.98,
    width: 59.11,
    height: 83.02,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 9.851666666666667
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 51.775,
    y: 658.49
  }, "\n        Orange\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 45,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.33,
    y: 43.78,
    width: 61.51,
    height: 85.92,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 6.151
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 112.085,
    y: 86.74000000000001
  }, "\n        Rensselaer\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 46,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 142.84,
    y: 43.78,
    width: 62.18,
    height: 85.92,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 5.652727272727272
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 173.93,
    y: 86.74000000000001
  }, "\n        Schenectady\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 47,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 205.02,
    y: 43.78,
    width: 65.61,
    height: 85.92,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 9.372857142857143
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 237.82500000000002,
    y: 86.74000000000001
  }, "\n        Niagara\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 48,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 270.63,
    y: 43.78,
    width: 66.74,
    height: 85.92,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 8.3425
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 304,
    y: 86.74000000000001
  }, "\n        Richmond\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 49,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 337.37,
    y: 43.78,
    width: 67.9,
    height: 85.92,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 11.316666666666668
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 371.32,
    y: 86.74000000000001
  }, "\n        Broome\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 50,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 405.27,
    y: 43.78,
    width: 87.7,
    height: 85.92,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 12.274285714285714
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 449.12,
    y: 86.74000000000001
  }, "\n        Suffolk\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 51,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 492.97,
    y: 43.78,
    width: 87.89,
    height: 85.92,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.32
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 536.9150000000001,
    y: 86.74000000000001
  }, "\n        Oneida\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 52,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 580.86,
    y: 43.78,
    width: 119.14,
    height: 85.92,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 14.32
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 640.4300000000001,
    y: 86.74000000000001
  }, "\n        Albany\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 53,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.33,
    y: 129.7,
    width: 123.6,
    height: 97.05,
    style: {
      fill: "#FFD4D4"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 12.13125
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 143.13,
    y: 178.225
  }, "\n        Onondaga\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 54,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.33,
    y: 226.75,
    width: 123.6,
    height: 145.78,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 20.599999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 143.13,
    y: 299.64
  }, "\n        Monroe\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 55,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.33,
    y: 372.53,
    width: 123.6,
    height: 149.87,
    style: {
      fill: "#FF4C4C"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 20.599999999999998
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 143.13,
    y: 447.465
  }, "\n        Nassau\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 56,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 81.33,
    y: 522.4,
    width: 123.6,
    height: 177.6,
    style: {
      fill: "#FF7F7F"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 11.236363636363636
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 143.13,
    y: 611.1999999999999
  }, "\n        Westchester\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 57,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 204.93,
    y: 129.7,
    width: 181.8,
    height: 163.52,
    style: {
      fill: "#C5E1FF"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 40.88
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 295.83000000000004,
    y: 211.45999999999998
  }, "\n        Erie\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 58,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 386.73,
    y: 129.7,
    width: 313.27,
    height: 163.52,
    style: {
      fill: "#FFB2B2"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "black",
      fontSize: 27.253333333333334
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 543.365,
    y: 211.45999999999998
  }, "\n        Queens\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 59,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 204.93,
    y: 293.22,
    width: 274.18,
    height: 188.15,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 37.63
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 342.02,
    y: 387.295
  }, "\n        Bronx\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 60,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 204.93,
    y: 481.37,
    width: 274.18,
    height: 218.63,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 27.32875
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 342.02,
    y: 590.685
  }, "\n        New_York\n      ")), /*#__PURE__*/React.createElement("g", {
    key: 61,
    transform: "scale(1, 1)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 479.11,
    y: 293.22,
    width: 220.89,
    height: 406.78,
    style: {
      fill: "#4389E3"
    }
  }), /*#__PURE__*/React.createElement("text", {
    style: {
      fill: "white",
      fontSize: 44.178
    },
    dominantBaseline: "central",
    textAnchor: "middle",
    x: 589.5550000000001,
    y: 496.61
  }, "\n        Kings\n      ")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(Svg1944);
export default __webpack_public_path__ + "static/media/1944.3f8d104b77f9a57fe30a2b0740f0bc9e.svg";
export { ForwardRef as ReactComponent };